export enum ActionTypes {
    SET_APP_NAME = 'SET_APP_NAME',
    CREATE_ORGANIZATION = 'CREATE_ORGANIZATION',
    CREATE_COLLECTION = 'CREATE_COLLECTION',
    CREATE_ARTICLE = 'CREATE_ARTICLE',
    UPDATE_COLLECTIONS = 'UPDATE_COLLECTIONS',
    UPDATE_ARTICLES = 'UPDATE_ARTICLES',
    UPDATE_MEDIA = 'UPDATE_MEDIA',
    SET_LOGGED_IN_USER = 'SET_LOGGED_IN_USER',
    SET_SHOW_UNPUBLISHED_ARTICLES = 'SET_SHOW_UNPUBLISHED_ARTICLES',
    SET_SHOW_UNPUBLISHED_COLLECTIONS = 'SET_SHOW_UNPUBLISHED_COLLECTIONS',
}

export interface SetBooleanAction {
    type: string
    payload: boolean
    [extraProps: string]: unknown
}

export interface SetStringAction {
    type: string
    payload: string
    [extraProps: string]: unknown
}

export interface SetArrayAction {
    type: string
    payload: []
    [extraProps: string]: unknown
}


export interface SetUserAction {
    type: string
    payload: User
    [extraProps: string]: unknown
}

export interface Article {
    ID: number
    updated: number
    created: number
    deleted: boolean
    collectionID: number
    name: string
    content: string
    published: boolean
    orderIndex: number
    mediaID: number
}

export interface Collection {
    ID: number
    created: number
    updated: number
    deleted: boolean
    published: boolean
    name: string
    orderIndex: number
    mediaID: number
}

export interface User {
    ID: number
    created: number
    updated: number
    deleted: boolean
    email: string
    name: string
    mediaID: number
}

export interface Media {
    ID: number
    created: number
    updated: number
    deleted: boolean
    entityType: number // Article: 4
    entityID: number // articleID
    collectionID: number
    mimeType: string
    shortKey: string
    filename: string
    fileSize: string
    fileURL: string
    imageURL: string
    thumbURL: string
}

export interface RootStore {
    appName: string
    byline: string
    organizations: []
    collections: Array<Collection>
    articles: Array<Article>
    media: Array<Media>
    loggedInUser: User
    showUnpublishedArticles: boolean
    showUnpublishedCollections: boolean
}

export type AllActionTypes = SetBooleanAction | SetStringAction;